import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField } from '@material-ui/core';
import AlertError from '@material-ui/icons/ErrorOutline';
import ActionCheck from '@material-ui/icons/CheckCircle';
import { makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import classnames from 'classnames';
import { useTranslate } from 'ra-core';

const useStyle = makeStyles(theme => ({
	contentText: {
		minWidth: 400,
	},
	confirmPrimary: {
		color: theme.palette.primary.main,
	},
	confirmWarning: {
		color: theme.palette.error.main,
		'&:hover': {
			backgroundColor: fade(theme.palette.error.main, 0.12),
			// Reset on mouse devices
			'@media (hover: none)': {
				backgroundColor: 'transparent',
			},
		},
	},
	iconPaddingStyle: {
		paddingRight: '0.5em',
	},
}));

const LockWalletsDialog = ({ open, onConfirm, onClose }) => {
	const [loading, setLoading] = useState(false);
	const translate = useTranslate();
	const classes = useStyle();

	const handleConfirm = e => {
		e.stopPropagation();
		setLoading(true);
		onConfirm();
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
		>
			<DialogTitle id="alert-dialog-title">{translate('coreWalletAdmin.wallets.list.lockDialog.title')}</DialogTitle>
			<DialogContent>
				<DialogContentText className={classes.contentText}>
					{translate('coreWalletAdmin.wallets.list.lockDialog.prompt')}
				</DialogContentText>
				<TextField
					autoFocus
					margin="dense"
					id="description"
					label="Reason"
					type="text"
					fullWidth
					/>
			</DialogContent>
			<DialogActions>
				<Button disabled={loading} onClick={onClose}>
					<AlertError className={classes.iconPaddingStyle} />
					{translate('coreWalletAdmin.common.cancelButton')}
				</Button>
				<Button
					disabled={loading}
					onClick={handleConfirm}
					className={classnames('ra-confirm', classes.confirmWarning)}
					autoFocus
				>
					<ActionCheck className={classes.iconPaddingStyle} />
					{translate('coreWalletAdmin.common.confirmButton')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default LockWalletsDialog;
